import React from 'react';
import PageHeader from 'components/PageHeader';
import styles from './PageHeaderLayout.module.less';
import { Alert } from 'antd';
import { _ } from 'ag-grid';

function CompareVersion(ver1, ver2) {
  var vals1 = ver1.split(".");
  var vals2 = ver2.split(".");
  var i = 0;
  // set index to first non-equal ordinal or length of shortest version string
  while (i < vals1.length && i < vals2.length && vals1[i] == vals2[i]) {
      i++;
  }

  if (i < vals1.length && i < vals2.length) {
      var diff = parseInt(vals1[i]) - parseInt(vals2[i]);
      return diff;
  } else {
    return vals1.length - vals2.length;
  }    
}


class VersionWarning extends React.Component {
    render = () => {      
      var aVersion = window.aVersion;
      var latestAVersion = window.latestAVersion;
      if (aVersion == "{{{aVersion}}}") {
        return "";
      }
      if (CompareVersion(aVersion, latestAVersion) < 0) {
        var message = "Your current version is: v" + aVersion + ". There is a new version: v" + latestAVersion + ". Please update ASAP.";
        return (<Alert message={message} banner />);
      } else {
        return "";
      }
    }
}

export default ({ children, wrapperClassName, top, ...restProps }) => (
  <div style={{ margin: '-24px -24px 0' }} className={wrapperClassName}>
    {top}
    <VersionWarning />
    <PageHeader key="pageheader" {...restProps} />    
    {children ? <div className={styles.content}>{children}</div> : null}
  </div>
);